import { Order } from '#web-components/types/table';
import { ListFilterOptions } from '#shared/types/common';

export const ALL_TASKS_FILTER_PARAMS: ListFilterOptions = {
  sortBy: 'id',
  sortOrder: Order.desc,
  firstResult: 0,
  maxResults: 100000,
};
